
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { NAttachment, NAttachments, NAttachmentsI18n } from '@/uikit/attachments';
import SearchFromSelect from '@/pages/search/SearchFromSelect.vue';
import { SearchSourceViewModel } from '@/pages/search/SearchSourceViewModel.ts';
import { SearchFromMap } from '@/store/application/data.assets';

@Options({
  name: 'SearchOverlay',
  components: {
    NAttachments,
    SearchFromSelect
  },
  emits: ['search']
})
export default class SearchOverlay extends Vue {
  @Prop({ type: Object, required: true })
  sourceModule!: SearchSourceViewModel;

  get state() {
    return this.sourceModule.state;
  }

  get loading() {
    return this.sourceModule.loading;
  }

  get loaded() {
    return this.sourceModule.loaded;
  }

  get SearchFromMap() {
    return SearchFromMap;
  }

  get attachmentsI18n(): NAttachmentsI18n {
    return {
      droparea_label: this.$t('search.drag_and_drop_files', 'f'),
      droparea_link_label: this.$t('search.select_files')
    };
  }

  handleFileUpload([v]: NAttachment[]) {
    v.status = 'done';
    this.sourceModule.load(v);
  }
}
